export const PERFORMANCE_TRACKER_PRODUCT_NAME = 'homeAndAuto';

export const APP_TIME_TO_INITIAL_RENDER = `${PERFORMANCE_TRACKER_PRODUCT_NAME}AppTimeToInitialRender`;
export const APP_TIME_TO_INTERACTIVE = `${PERFORMANCE_TRACKER_PRODUCT_NAME}AppTimeToInteractive`;
export const SAVE_EZLYNX_APPLICANT = `${PERFORMANCE_TRACKER_PRODUCT_NAME}SaveEzLynxApplicant`;

export const getFormSubmitPerformanceEventName = (formId: string) => {
  if (!formId) {
    return;
  }

  return `${PERFORMANCE_TRACKER_PRODUCT_NAME}FormSubmit - ${formId}`;
};

export const getPerformanceEvent = (performanceEvent: string) => {
  if (!(window as any).PGPerformance) {
    return;
  }

  return (window as any).PGPerformance.getPerformanceEvent(performanceEvent);
};

export const trackPerformanceEvent = (performanceEvent: string) => {
  if (!(window as any).PGPerformance) {
    return;
  }

  (window as any).PGPerformance.trackPerformanceEvent(
    performanceEvent,
    null,
    PERFORMANCE_TRACKER_PRODUCT_NAME
  );
};

export const resetPerformanceEvent = (performanceEvent: string) => {
  if (!getPerformanceEvent(performanceEvent)) {
    return;
  }

  (window as any).PGPerformance.resetPerformanceEvent(performanceEvent);
};
